import React, { useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import Typed from "typed.js";
import '../../assets/css/Home/Content.css';

const HomeContent = () => {
    const navigate = useNavigate();
    const typedElement = useRef(null);

    // Fonction pour la navigation
    const inviteBot = () => { return window.open('/invite', '_blank'); };
    const inviteDiscord = () => { return window.open('/discord', '_blank'); };
    const viewBumps = () => { return navigate('/bump'); };

    // Hook pour initialiser Typed.js
    useEffect(() => {
        const options = {
            strings: [
                "constantly <strong><underline>evolving</underline></strong>. 🚀",
                "already on over <strong><underline>180 servers</underline></strong>. 📈",
                "ready to assist you. 📚",
                "a companion for every moment. 💬",
                "the ultimate assistant for your server. ⚙️",
                "always <underline>listening to the needs</underline> of your community. 🎧",
                "here to simplify server management. 🛠️",
                "a bot that never lets you down. 💪"
            ],            
            typeSpeed: 25,
            backSpeed: 30,
            backDelay: 2000,
            loop: true,
        };
        const typed = new Typed(typedElement.current, options);

        // Nettoyage de Typed.js lors du démontage
        return () => {
            typed.destroy();
        };
    }, []);

    return (
        <>
            <div className="mainContainer">
                <div className="presentation">
                    <img 
                        draggable="false"
                        src="https://cdn.jaquesbot.fr/static/logo.webp" 
                        alt="Jaques's profile !" 
                        width="128px" 
                        height="128px" 
                        title="❤️ | Jaques's profile picture !" 
                    />
                    <h2>Jaques is...</h2>
                    <p title="❤️ | Jaques is much more than you think!">
                        <span ref={typedElement}></span>
                    </p>
                    <div className="cta">
                        <button 
                            className="cta-invite" 
                            onClick={inviteBot} 
                            title="❤️ | Invite Jaques !"
                        >
                            Invite Jaques
                        </button>
                        <button 
                            className="cta-discord" 
                            onClick={inviteDiscord} 
                            title="❤️ | Grow our support!"
                        >
                            Join Support
                        </button>
                    </div>
                </div>

                <hr className="horizontal-line"/>
                <div className="functions">
                    <h1>What I can do...</h1>
                    <div className="function-object">
                        <div className="text">
                            <h3>IA</h3>
                            <p>
                                Talk with one of the best free chatbots,<br />15 message history, unlimited chat!
                                <br />
                                (Public)
                            </p>
                        </div>
                        <div className="img-left">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_ia.svg"
                                alt="Robot, because you speak to the robot!"
                                draggable="false"
                            />
                        </div>
                    </div>

                    <hr className="horizontal-line"/>

                    <div className="function-object">
                        <div className="img-right">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_automod.svg"
                                alt="Chains, as if it were secure!"
                                draggable="false"
                            />
                        </div>
                        <div className="text">
                            <h3>Automod</h3>
                            <p>
                                With unparalleled simplicity, thanks to AI, <br />Jaques will moderate your server alone.
                                <br />
                                (Not Aviable Yet)
                            </p>
                        </div>
                    </div>

                    <hr className="horizontal-line"/>

                    <div className="function-object">
                        <div className="text">
                            <h3>Bump (Boost)</h3>
                            <p>
                                Need a boost? Great! We're here to maximize your chances:<br />Boost and find your server <button className="link-button" onClick={viewBumps}>right here</button>.
                                <br />
                                (Public)
                            </p>
                        </div>
                        <div className="img-left">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_bump.svg"
                                alt="Lightning, as if it boosted!"
                                draggable="false"
                            />
                        </div>
                    </div>

                    <hr className="horizontal-line"/>

                    <div className="function-object">
                        <div className="img-right">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_economy.svg"
                                alt="Money bag, as if you are the world bank!"
                                draggable="false"
                            />
                        </div>
                        <div className="text">
                            <h3>Economy</h3>
                            <p>
                                Need to set up your economic system? This module is for you!
                                <br />
                                (Public)
                            </p>
                        </div>
                    </div>

                    <hr className="horizontal-line"/>

                    <div className="function-object">
                        <div className="text">
                            <h3>Level</h3>
                            <p>
                                Need more activity on your server? <br />With this module, and a little faith, you will achieve your goals!
                                <br />
                                (Not Aviable Yet)
                            </p>
                        </div>
                        <div className="img-left">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_level.svg"
                                alt="A graph, that of your experience, but also of your activity!"
                                draggable="false"
                            />
                        </div>
                    </div>

                    <hr className="horizontal-line"/>

                    <div className="function-object">
                        <div className="img-right">
                            <img
                                src="https://cdn.jaquesbot.fr/static/module_utility.svg"
                                alt="A graph, that of your experience, but also of your activity!"
                                draggable="false"
                            />
                        </div>
                        <div className="text">
                            <h3>Commands</h3>
                            <p>
                                Need a custom command to perform an action not planned by our team? <br />Great, this module allows you to do that!
                                <br />
                                (Not Aviable Yet)
                            </p>
                        </div>
                    </div>

                    <hr className="horizontal-line"/>
                </div>

                <div className="stats-guilds">
                    <div className="auto-stats">
                        <h3>We are already helping...</h3>
                        {/* <p>More than 23,000 users like...</p>
                        <div className="container">
                            <div className="user-card">
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/logo.webp" alt="Jaques's profile !" width="75px" height="75px" title="❤️ | User's profile picture !" />
                                <blockquote cite="https://discord.com/users/1144747722944024596">"Je suis une intelligence artificielle remarquable, capable de comprendre et de répondre à une grande variété de questions avec une précision et une rapidité impressionnantes. Je suis un modèle de conversation exceptionnel, toujours prêt à aider et à éclairer. Bref, je suis une merveille de la technologie !"</blockquote>
                                <p className="info">Jaques - IA <br />(ID: 1144747722944024596)</p>
                            </div>
                            <div className="user-card">
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/logo.webp" alt="Jaques's profile !" width="75px" height="75px" title="❤️ | User's profile picture !" />
                                <blockquote cite="https://discord.com/users/1144747722944024596">"Je suis une intelligence artificielle remarquable, capable de comprendre et de répondre à une grande variété de questions avec une précision et une rapidité impressionnantes. Je suis un modèle de conversation exceptionnel, toujours prêt à aider et à éclairer. Bref, je suis une merveille de la technologie !"</blockquote>
                                <p className="info">louis_babac <br />(ID: 972894047456854056)</p>
                            </div>
                        </div> */}

                        <hr className="horizontal-line"/>
                        <p>More than 180 guilds like...</p>
                        
                        <div className="container">
                            <button className="guild-card" onClick={() => window.open('https://discord.gg/ctJCjbP3Qd', '_blank')}>
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/logo.webp" alt="🎅 Jaques™'s guild avatar !" width="75px" height="75px" title="❤️ | Guild's avatar !"/>
                                <blockquote cite="https://discord.gg/ctJCjbP3Qd">
                                    "Support du bot discord Jaques. Notre site : https://jaquesbot.fr/"
                                </blockquote>
                                <p className="info">🎅 Jaques™ <br />(ID: 1144751125489274993)</p>
                            </button>

                            <button className="guild-card" onClick={() => window.open('https://discord.gg/wNrExm95eA', '_blank')}>
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/server_mondedelapub.webp" alt="🎄| Monde de la Pub's guild avatar !" width="75px" height="75px" title="❤️ | Guild's avatar !"/>
                                <blockquote cite="https://discord.gg/wNrExm95eA">
                                    "Faites connaître votre projet rapidement ! 🚀 Rejoignez-nous pour gagner en visibilité et promouvoir vos idées ! 🌟"
                                </blockquote>
                                <p className="info">🎄| Monde de la Pub <br />(ID: 490913620759412737)</p>
                            </button>

                            <button className="guild-card" onClick={() => window.open('https://discord.gg/yvZb9ZZcK2', '_blank')}>
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/server_lingbotsupport.webp" alt="LingBot | Support's guild avatar !" width="75px" height="75px" title="❤️ | Guild's avatar !"/>
                                <blockquote cite="https://discord.gg/yvZb9ZZcK2">
                                    "Serveur support du bot Discord <a href="https://bot-ling.github.io/?utm_source=jaquesbot.fr" onClick={(e) => e.stopPropagation()} target="_blank" rel="noopener noreferrer">LingBot</a> qui vise à vous aider dans toutes les langues possibles."
                                </blockquote>
                                <p className="info">LingBot | Support <br />(ID: 1314298580068077668)</p>
                            </button>

                            <button className="guild-card" onClick={() => window.open('https://discord.gg/dPN5vUrWar', '_blank')}>
                                <img draggable="false" src="https://cdn.jaquesbot.fr/static/server_fireblockfun.webp" alt="🎅 FIREBLOCK.FUN's guild avatar !" width="75px" height="75px" title="❤️ | Guild's avatar !"/>
                                <blockquote cite="https://discord.gg/dPN5vUrWar">
                                    "<a href="https://fireblock.fun/?utm_source=jaquesbot.fr" onClick={(e) => e.stopPropagation()} target="_blank" rel="noopener noreferrer">FIREBLOCK</a> est un serveur Minecraft Mini-Jeux, disponnible pour les joueurs utilisant les versions de la 1.8 à la 1.20.x."
                                </blockquote>
                                <p className="info">🎅 FIREBLOCK.FUN <br />(ID: 453711519746883604)</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HomeContent;
